import Section from '@/components/Section';
import Container from '@/components/Container';
import SectionContactSells from './SectionContactSells';
import SectionContactTrainers from './SectionContactTrainers';
import SectionContactConsulting from './SectionContactConsulting';

export default function SectionContactLinks() {
  return (
    <Section className="pb-10 lg:pb-20 relative z-10">
      <div className="grid grid-cols-12 transform -skew-y-6">
        <div className="absolute left-0 z-0 right-0 top-0 h-28 bg-gradient-to-r from-green-300 via-green-100 to-green-300 mt-10" />
        <div className="absolute left-0 z-10 w-full top-0 h-52 bg-gradient-to-r from-green-100 to-transparent -mt-24" />
        <div className="absolute left-0 z-10 w-2/4 top-0 h-52 bg-gradient-to-r from-green-200 to-transparent -mt-14" />
        <div className="absolute left-0 z-10 w-2/3 top-0 h-20 bg-gradient-to-r from-green-400 to-transparent mt-2" />
      </div>
      <Container className="relative z-50">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <SectionContactSells />
          <SectionContactConsulting />
          <SectionContactTrainers />
        </div>
      </Container>
    </Section>
  );
}
